import { ActionBase } from '../../../core/store/action/ActionBase';
import { DynamicDataSetModel } from '../../models/DynamicDataSetModel';

export const UNFINALIZE_DYNAMICDATASET_SUCCESS = '[DynamicDataSet] Unfinalize Success';

export class UnfinalizeDynamicDataSetSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = UNFINALIZE_DYNAMICDATASET_SUCCESS;

  constructor(public payload: { dynamicDataSet: DynamicDataSetModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/actions/UnfinalizeDynamicDataSetSuccessAction.ts